import React, { Component } from 'react';
import { TextField, RaisedButton } from 'material-ui';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import '../PasswordReset/PasswordReset.css';
import '../Login/Login.css';
import './PasswordConfirm.css';
import getMuiTheme from 'material-ui/styles/getMuiTheme';


const muiTheme = getMuiTheme({
  fontFamily: 'Open Sans',
});

const passwordConfirmStyle = {
  color: '#55aef6',
  borderColor: '#55aef6'
};


export default class PasswordConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: null,
      passwordConfirm: null,
      passwordChanged: false,
      invalidToken : false,
    };

    this.changePasswordConfirm = this.changePasswordConfirm.bind(this);
  }

  // Change the state to display the message for success and redirect the user to login.
  changePasswordConfirm = (response) => {
    const responseStatus = response.status;
    if (responseStatus === 200) {
      this.setState({
        passwordChanged: true,
      });
    }
    else {
      this.setState({
        invalidToken: true,
      });
    }

    // Redirect after 3 seconds.
    window.setTimeout(function(){
      window.location = window.location.origin;
    }, 3000);
  };

  confirmPassword = () => {

    let url = window.location.href;
    let tokenValue = url.substring(url.indexOf('token') + 6);
    let data = {
      token: tokenValue,
      password: this.state.password,
    };

    /* Password validation. */
    if ((this.state.password === this.state.passwordConfirm)) {
      if (this.state.password !== '' && this.state.password !== null) {
        fetch(`${process.env.REACT_APP_API_HOST}user/change_password/confirm`, {
          body: JSON.stringify(data),
          method: 'POST',
          headers: {
            'Access-Control-Allow-Origin': '*',
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }).then(response => this.changePasswordConfirm(response));
      }
      else {
        this.setState({
          password: '',
          passwordConfirm: ''
        });
      }
    }

  };

  render() {
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div className="password-confirm-main loginForm">
          <div className="loginForm-inner">
            <h2 className="password-confirm-title">Unesite novu lozinku: </h2>

            <TextField
              floatingLabelText={"Vaša nova lozinka: "}
              floatingLabelFixed={true}
              underlineFocusStyle={passwordConfirmStyle}
              floatingLabelFocusStyle={passwordConfirmStyle}
              type="password"
              onChange={(event) => {
                this.setState({
                  password: event.target.value,
                })
              }}
            />

            <TextField
              floatingLabelFixed={true}
              type="password"
              underlineFocusStyle={passwordConfirmStyle}
              floatingLabelFocusStyle={passwordConfirmStyle}
              floatingLabelText={"Potvrdite vašu novu lozinku: "}
              onChange={(event) => {
                this.setState({
                  passwordConfirm: event.target.value,
                })
              }}
            />

            <RaisedButton
              label={"Potvrdi"}
              onClick={this.confirmPassword.bind(this)}
              backgroundColor="#90caf9"
              labelColor="#ffffff"
              style={{ display: "block", marginRight: 35, marginLeft: 35, marginTop: 35 }}
            />
            { /* Message if password didn't match. */}
            {this.state.password !== this.state.passwordConfirm ?
              <p className="password-validation-message">Šifre se ne poklapaju!</p> : null}
            {this.state.password === '' ?
              <p className="password-validation-message">Šifra ne može biti prazna!</p> : null}
            {/* Message that will appear if server response is 200 (and password is successfully changed. */}
            {this.state.passwordChanged ?
              <p className="login-password-message">Lozinka je uspešno promenjena!</p> : null}
            {/* Message if the token is no longer valid. */}
            {this.state.invalidToken ?
              <p className="password-validation-message">Greška, link više nije važeći!</p> : null}
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/PasswordConfirm/PasswordConfirm.jsx